<template>
  <div>
    <userEditor
      @userConfigured="handleUser"
      ref="userEditor"
      v-model="userEditorDialog"
    ></userEditor>
    <messageBox ref="msgBox" />

    <v-row class="text-center">
      <v-col>
        <v-progress-circular
          v-if="fetchingData"
          :indeterminate="true"
          :rotate="0"
          :size="32"
          :width="4"
          color="light-blue"
        ></v-progress-circular>
      </v-col>
    </v-row>

    <v-card v-if="!fetchingData" class="ma-4">
      <v-toolbar color="primary" dark>
            <v-app-bar-nav-icon
              ><v-icon large>mdi-account-edit</v-icon>
            </v-app-bar-nav-icon>
            <v-toolbar-title>Gestione utenti</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <div style="height:10px"/>
      <v-row class="text-center" align="center" justify="center"
        ><v-btn v-on:click="addUser()" color="red" dark>Aggiungi utente</v-btn>
      </v-row>
      <v-row class="ml-2">
        <v-col >
          <v-text-field
            outlined
            v-model="filter"
            append-icon="mdi-magnify"
            class="mr-auto ml-1 pl-1"
            label="Ricerca"
            hide-details
          />
        </v-col>
      

        <v-col >
          <v-select
            v-model="filters.access"
            outlined
            item-text="name"
            item-value="state"
            :items="accessesList"
            label="Accesso"
            hide-details
          />
        </v-col>

        <v-col >
          <v-select
            v-model="filters.role"
            outlined
            item-text="name"
            item-value="role"
            :items="rolesList"
            label="Ruolo"
            hide-details
          />
        </v-col>

      </v-row>

      <div class="vertical-spacer" />
      <v-data-table
        class="grid-table"
        :items-per-page="perPage"
        :must-sort="true"
        :headers="headers"
        :items="users"
        :options.sync="options"
        :server-items-length="totalUsers"
        :loading="loading"
        :footer-props="dataTableFooterOptions"
      >
        <template v-slot:item.first_name="{ item }">
          <v-avatar v-if="checkGravatar(item) && getGravatar(item)">
            <v-img :src="getGravatar(item)" :alt="getUsername(item)" />
          </v-avatar>

          <v-avatar v-else-if="getProfileLetters(item)" color="green" size="48">
            <span class="white--text headline">{{
              getProfileLetters(item)
            }}</span>
          </v-avatar>
          {{ item.first_name }}
        </template>
        <template v-slot:item.roles="{ item }">
          {{ getRole(item) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom
            ><template v-slot:activator="{ on }"
              ><v-btn
                :disabled="
                  !can_act_on_item(item) ||
                    !item.can_be_edited ||
                    item.id == $store.state.user.id
                "
                x-small
                text
                icon
                color="primary"
                @click.stop="editItem(item)"
                v-on="on"
                ><v-icon>mdi-account-edit</v-icon></v-btn
              ></template
            ><span>Modifica utente</span></v-tooltip
          >
          <v-tooltip v-if="item.banned" bottom
            ><template v-slot:activator="{ on }"
              ><v-btn
                :disabled="
                  !can_act_on_item(item) ||
                    !item.can_be_edited ||
                    item.id == $store.state.user.id
                "
                x-small
                text
                icon
                color="green"
                @click.stop="banItem(item)"
                v-on="on"
                ><v-icon>mdi-account</v-icon></v-btn
              ></template
            ><span>Sblocca utente</span></v-tooltip
          >
          <v-tooltip v-if="!item.banned" bottom
            ><template v-slot:activator="{ on }"
              ><v-btn
                :disabled="
                  !can_act_on_item(item) ||
                    !item.can_be_edited ||
                    item.id == $store.state.user.id
                "
                x-small
                text
                icon
                color="error"
                @click.stop="banItem(item)"
                v-on="on"
                ><v-icon>mdi-account-off</v-icon></v-btn
              ></template
            ><span>Blocca utente</span></v-tooltip
          >
          <v-tooltip
            v-if="
              item.can_be_deleted &&
                item.id != $store.state.user.id &&
                can_act_on_item(item)
            "
            bottom
            ><template v-slot:activator="{ on }"
              ><v-btn
                x-small
                text
                icon
                color="error"
                @click.stop="deleteItem(item)"
                v-on="on"
                ><v-icon>mdi-delete</v-icon></v-btn
              ></template
            ><span>Rimuovi utente</span></v-tooltip
          >
          <v-tooltip
            v-if="
              !can_act_on_item(item) ||
                !item.can_be_deleted ||
                item.id == $store.state.user.id
            "
            bottom
            ><template v-slot:activator="{ on }"
              ><v-btn :disabled="true" x-small text icon color="error" v-on="on"
                ><v-icon>mdi-delete</v-icon></v-btn
              ></template
            ><span>Rimuovi utente</span></v-tooltip
          >
        </template>
        <template v-slot:item.banned="{ item }">
          {{ item.banned ? "No" : "Si" }}
        </template>
      
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import userManager from "../../apis/users";
import staticData from "../../apis/staticData";

import AvatarServices from "../../services/avatars";

import messageBox from "../../components/MessageBox.vue";
import userEditor from "../../components/UserEditor.vue";

export default {
  data() {
    return {
      dataTableFooterOptions: staticData.dataTableFooterOptions,

      users: [],
      loading: false,
      totalUsers: 0,
      options: {
        sortBy: ["last_name"],
        sortDesc: [false]
      },
      headers: [],
      perPage: staticData.defaultPerPage,
      filter: "",
       filters: {
        region: null,
        access : null,
        role : null
      },
      accessesList : [],
      rolesList : [],
      regions: {},
      regionsMap: {},
      regionsList: [],
      fetchingData: false,
      userEditorDialog: false,
      roles: ["sa", "a", "r", "u"]
    };
  },

  components: {
    userEditor,
    messageBox
  },

  mounted() {
    this.headers = [
      { text: "Nome", align: "left", sortable: true, value: "first_name" },
      { text: "Cognome", align: "center", sortable: true, value: "last_name" },
      { text: "E-mail", align: "center", sortable: true, value: "email" },
      { text: "Ruolo", align: "center", sortable: true, value: "roles" },
      { text: "Accesso", align: "center", sortable: true, value: "banned" },
      { text: "", align: "center", sortable: false, value: "actions" }
    ];
    this.fetchingData = true;
   
        this.accessesList = [{ state: null, name: "Tutti" },{ state: 1 , name : "Attivo"},{ state: 2 , name : "Disattivo"}] ;
        this.rolesList = [{ role: null, name: "Tutti" },{ role: 'sa' , name : "Root"},{ role: 'a' , name : "Amministratore"},{ role: 'r' , name : "Revisore"},{ role: 'u' , name : "Utente"}] ;
        
        this.fetchingData = false;
     
  },

  watch: {
    options: {
      handler() {
        clearTimeout(this._debounceTimer);
        this._debounceTimer = setTimeout(() => {
          this.reloadUsers(true);
        }, 300);
      },
      deep: true
    },

    filter: {
      handler() {
        clearTimeout(this._debounceTimer);
        this._debounceTimer = setTimeout(() => {
          this.reloadUsers(true);
        }, 300);
      }
    },

    filters: {
      handler() {
        clearTimeout(this._debounceTimer);
        this._debounceTimer = setTimeout(() => {
          this.reloadUsers(true);
        }, 300);
      },

      deep: true,
      immediate: true
    }
  },

  methods: {
    can_act_on_item: function(item) {
      if (!this.$store.state.user) return false;
      if (!this.$store.state.user.roles) return false;
      if (
        this.roles.indexOf(this.$store.state.user.roles) <=
        this.roles.indexOf(item.roles)
      )
        return true;
      return false;
    },

    reloadUsers: function(showLoader) {
      this.fetchUsers(showLoader)
        .then(data => {
          this.users = data.items;
          this.totalUsers = data.totalCount;
        })
        .catch(err => {
          console.log(err);
        });
    },

    getGravatar: function(item) {
      if (!item.gravatar) return null;
      return "data:image/jpeg;base64," + item.gravatar;
    },

    getUsername: function(item) {
      return item.name;
    },

    checkGravatar: function(item) {
      if (!item.gravatarFetched) {
        item.gravatarFetched = true;
        AvatarServices.fetchAvatar(item.id)
          .then(result => {
            item.first_name = Object.assign(item.first_name);
            item.gravatar = result.avatar;
          })
          .catch(err => {
            console.log(err);
          });
      }
      return true;
    },

    getProfileLetters: function(user) {
      if (user.first_name && user.last_name) {
        if (user.first_name.length && user.last_name.length) {
          return (
            user.first_name.toUpperCase()[0] + user.last_name.toUpperCase()[0]
          );
        }
      }

      return "";
    },

    getRole(item) {
      if (item.roles.includes("sa")) return "SA";
      else if (item.roles.includes("a")) return "Amministratore";
      else if (item.roles.includes("r")) return "Revisore";
      return "Utente";
    },

    fetchUsers(showLoader) {
      if (showLoader) this.loading = true;
      return new Promise((resolve, reject) => {
        let ctx = Object.assign({}, this.options);
        ctx.currentPage = ctx.page;
        ctx.perPage = ctx.itemsPerPage != -1 ? ctx.itemsPerPage : null;
        ctx.filter = this.filter;
        ctx.filters = this.filters;
        ctx.sortBy = ctx.sortBy[0];
        ctx.sortDesc = ctx.sortDesc[0];
        userManager
          .fetchUsers(ctx)
          .then(result => {
            if (showLoader) this.loading = false;
            resolve(result);
          })
          .catch(err => {
            if (showLoader) this.loading = false;
            console.log(err);
            reject();
          });
      });
    },

    handleUser(event) {
      this.userEditorDialog = false; // Close dialog

      if (event.editingUser) {
        let user = event.user;
        userManager
          .updateUser(user)
          .then(() => {
            this.reloadUsers(false);
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        let user = event.user;
        userManager
          .addUser(user)
          .then(() => {
            this.reloadUsers(false);
          })
          .catch(err => {
            console.log(err);
          });
      }
    },

    banItem(item) {
      userManager
        .banUser(item)
        .then(() => {
          item.banned = !item.banned;
        })
        .catch(() => {});
    },

    deleteItem(item) {
      let userId = item.id;
      this.$refs.msgBox
        .show(
          "Vuoi davvero confermare la cancellazione dell' utente ?",
          "Conferma operazione"
        )
        .then(() => {
          userManager
            .removeUser(userId)
            .then(() => {
              this.reloadUsers(false);
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => {});
    },

    editItem(item) {
      let user = JSON.parse(JSON.stringify(item));
      this.$refs.userEditor.resetModal();
      this.$refs.userEditor.setModalUser(user, true, this.regionsList);
      this.userEditorDialog = true;
    },

    addUser() {
      this.$refs.userEditor.resetModal();
      this.$refs.userEditor.setModalUser(
        {
          first_name: "",
          last_name: "",
          email: "",
          roles: "u"
        },
        false,
        this.regionsList
      );
      this.userEditorDialog = true;
    }
  }
};
</script>
